import { A } from '@ember/array';
import Service from '@ember/service';

export default Service.extend({

  /////////////////////////////////
  // forceArray(obj)
  //
  // * Coerces an object into an array.  Useful for Ember objects
  // * that behave like arrays but don't have any of their
  // * common properties/methods.
  /////////////////////////////////

  forceArray(obj) {
    if(!Array.isArray(obj) && typeof obj.toArray === 'function') {
      obj = obj.toArray();
    } else if (!Array.isArray(obj)) {
      obj = A([obj]);
    } else {
      obj = obj.slice();
    }

    return obj;
  },

  /////////////////////////////////
  // sortModel(model, sortingCriteria)
  //
  // * Takes a model and a property:asc/desc modifier to
  // * sort by.  Attempts to intelligently compare the items
  // * based on their type.
  /////////////////////////////////

  sortModel(model, sortingCriteria) {

    if(!Array.isArray(model)) {
      try {
        model = model.toArray();
      } catch(e) {
        throw 'Your model-to-be-sorted must either be an array or an object with a toArray() method';
      }
    } else {
      model = model.slice();
    }

    let sortingFunction;

    if(typeof sortingCriteria === 'function') {
      sortingFunction = sortingCriteria;
    } else {

      const regex = /(.*):(asc|ASC|desc|DESC)$/;

      let matches = regex.exec(sortingCriteria);
      let modifier;

      if(matches !== null) {
        sortingCriteria = matches[1];
        modifier = (matches[2].toLowerCase() === 'desc') ? -1 : 1;
      } else {
        modifier = 1;
      }

      let comparator = function (a, b) {
        let toReturn;

        if (a < b) {
          toReturn =  (-1 * modifier);
        } else if (a > b) {
          toReturn = (1 * modifier);
        } else {
          toReturn =  0;
        }
        return toReturn;
      };

      sortingFunction = function (a, b) {
        let modifiedValues = [];

        [a,b].forEach(function(item, index) {
          switch (typeof item.get(sortingCriteria)) {
            case 'string' :
              modifiedValues[index] = item.get(sortingCriteria).toLowerCase();
              break;
            case 'date' :
              modifiedValues[index] = item.get(sortingCriteria).getTime();
              break;
            case 'number' :
              modifiedValues[index] = item.get(sortingCriteria);
              break;
            default :
              modifiedValues[index] = item.get(sortingCriteria);
              break;
          }
        });
        return comparator(modifiedValues[0], modifiedValues[1]);
      };
    }

    return model.sort(sortingFunction);

  }

});
